import React from 'react';
import PropTypes from 'prop-types';
import Card from 'reactstrap/lib/Card';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { getPriceString } from 'site-modules/shared/utils/price-utils';

import './price-checker-info.scss';

const EDMUNDS_LOGO_WIDTH = 24;

export function PriceCheckerInfo({ makeName = null, modelName = null, year = null, userMsrp = null }) {
  const logoSrc = getStaticImageUrl('/img/car-buying/steps/edmunds_logo_expert.svg');
  const price = getPriceString(userMsrp);

  return (
    <Card className="price-checker-info text-center p-2">
      <div className="fw-bold d-flex justify-content-between">
        <div className="p-0 d-flex flex-column align-items-center justify-content-end">
          <div>MSRP</div>
          <div className="text-gray heading-1 fw-bold">{price}</div>
        </div>
        <div className="ms-0_25 p-0 d-flex flex-column align-items-center justify-content-end">
          <img src={logoSrc} width={EDMUNDS_LOGO_WIDTH} className="edmunds-image me-0_5" alt="Edmunds" />
          <div>Edmunds Suggested Price</div>
          <div className="text-primary heading-1 fw-bold">{price}</div>
        </div>
      </div>
      <Card className="text-center d-block p-1_5 mt-2_5">
        The {year} {makeName} {modelName} has a set price by the manufacturer that is not negotiable. In a situation
        where the OEM’s prices are set with no negotiating, the{' '}
        <span className="fw-bold">Edmunds Suggested Price is equal to MSRP</span>.
      </Card>
    </Card>
  );
}

PriceCheckerInfo.propTypes = {
  makeName: PropTypes.string,
  modelName: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  userMsrp: PropTypes.number,
};
